import {connect} from 'react-redux';
import {actions} from '../../actions/actions';
import {Profile} from '../profile';

export const ProfileContainer = connect(
  function mapStateToProps(state) {
    return {
      authenticated: state.authReducer.authenticated,
      online: state.onlineReducer.online,
      displayName: state.authReducer.displayName,
      user: state.authReducer.user,
      userStatus: state.authReducer.status,
      card: state.ecommReducer.card,
      cardApproved: state.ecommReducer.submitted,
      prefs: state.authReducer.prefs,
      charges: state.ecommReducer.charges,
      progress: state.uploadReducer.progress
    };
  },
  function mapDispatchToProps(dispatch){
      return{
        onProfileChange: (displayName, userName) => {
         //dispatch with payload, handled by FirebaseAPI
         dispatch( actions.profile(displayName, userName) );
       },
        onDonate: (amount) =>{
          dispatch( actions.donate(amount));
        },
         onCard: (card) =>{
           dispatch( actions.card(card) );
         },
         onDeleteCard: ()=>{
           dispatch( actions.deleteCard() );
         },
         onImageUpload: (file)=>{
           //automatically assigns a "requested" status
           dispatch( actions.fileUpload(file) )
         }
      }
  }

)(Profile);



// WEBPACK FOOTER //
// ./../../../Documents/codeprojects/leaflet-v02/src/components/containers/profileContainer.js